<template>
  <div class="main-layout">
    <div class="main-layout__wrapper">
      <Navbar />
      <slot />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar';

export default {
  name: 'MainLayout',
  components: { Navbar },
};
</script>

<style lang="scss" scoped>
  .main-layout {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 114px 20px 32px;

    @include md-up {
      background: linear-gradient($topBackground 280px, $bottomBackground 280px);
      padding: 46px;
    }

    &__wrapper {
      max-width: 500px;
      width: 100%;

      @include md-up {
        max-width: 1280px;
      }
    }
  }
</style>
